import * as _ from "lodash";

class ErrorCode {
	static Invalid = {val: 0, name: "Invalid"};
	static FutureItemPlayed = {
		val: 1,
		name: "Future Item Played",
		tip: "Item was not played because a future item was started and stopped this one"
	};
	static EtmDropped= {val: 2, name: `Etm Dropped`};
	static UnsupportedEvent = {val: 3, name: "Unsupported Event"};
	static StoppedEarly = {val: 4, name: "Stopped Early"};
	static ExpiredOnStartup = {val: 5, name: "Expired On Startup"};
	static AssetNotDefined = {val: 6, name: "Asset Not Defined"};
	static AssetFilePathNotDefined = {val: 7, name: "Asset File Path Not Defined"};
	static PlayerLoadError = {val: 8, name: "Player Load Error"};
	static SyncToSelectionPast = {val: 9, name: "Sync to Selection Past"};
	static SyncToSelectionFuture = {val: 10, name: "Sync to Selection Future"};
	static ParentEventStopped = {val: 11, name: "Parent Event Stopped"};
	static NoAvailableStreams = {val: 12, name: "No Available Streams"};
	static SplitStoppedWithoutPlaying = {val: 13, name: "Split Stopped Without Playing"};
	static NotActive = {val: 14, name: "Not Active"};
	static InvalidAssetStartDate = {val: 15, name: "Invalid Asset Start Date"};
	static InvalidStationAssetEndDate = {val: 16, name: "Invalid Station Asset End Date"};
	static InvalidAssetKillDate = {val: 17, name: "Invalid Asset Kill Date"};
	static NoGeneratedFilePath = {val: 18, name: "Invalid Generated File Path"};
	static InvalidAssetReleaseDate = {val: 19, name: "Invalid Asset Release Date"};
	static UnPlayedShowEvent = {val: 20, name: "Unplayed show event"};
	static InvalidAssetEndDate = {val: 21, name: "Invalid Asset End Date"};
	static UnplayableEdgeOffline = {val: 22, name: "Unplayable Edge Offline"};
	static CloseEtm = {val: 23, name: "Close ETM"};
	static InvalidExecuteCommandType = {val: 24, name: "Invalid Execute Command Type"};
	static OverlappingShowEvent = {val: 25, name: "Overlapping show events"};
	static PoiMarkerPriorToTrimIn = {val: 26, name: "Event was prior to the shows fade in"};
	static HourRestrictions = {val: 27, name: "Falls within restricted hours"};
	static CustomShowDropped = {val: 28, name: "Higher priority playlist dropped"};
	static ShowChildWithoutParent = {val: 29, name: "Show child started without parent"};

	static getMessageByValue(val) {
		const error = _.values(this).find(i => i.val === val);
		let msg = error?.name ?? "Unknown Error";
		if (error?.tip) {
			msg += `, ${error.tip}`;
		}
		return msg;
	}
}

export default ErrorCode;